export class LedgerHeadMaster {
    public ledgerHeadId: number;
    public name: string;
    public entryType: string;
    public isDeemedPositive: boolean;
    public approvalStatus: boolean;
    public status: string;

    constructor(init?: Partial<LedgerHeadMaster>) {
        if (init) {
          Object.assign(this, init);
        }
    }
}